import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const FormsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  routes: [
    {
      path: routesUrl.formsHistory,
      exact: true,
      component: React.lazy(() => import('./pages/FormsListPage')),
    },
    {
      path: routesUrl.formsCreation,
      exact: true,
      component: React.lazy(() => import('./pages/FormsBuilderPage')),
    },
    {
      path: routesUrl.formsDetail,
      exact: true,
      component: React.lazy(() => import('./pages/FormsBuilderPage')),
    },
    {
      path: routesUrl.formsFill,
      exact: true,
      component: React.lazy(() => import('./pages/FormFillPage')),
    },
  ],
};

export default FormsAppConfig;
